import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Pagination from './../../common/Pagination';
import moment from 'moment';
import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';

class Table extends Component {
    static propTypes = {
        elements: PropTypes.array,
        handleSort: PropTypes.func,
        handleUpdateFormValue: PropTypes.func,
        isFetchingElements: PropTypes.bool,
        handleShowForm: PropTypes.func,
        handleShowDelete: PropTypes.func,
        totalPages: PropTypes.number,
        selectedPage: PropTypes.number,
        elementsPerPage: PropTypes.number,
        sortColumn: PropTypes.string,
        sortType: PropTypes.string,
        handleChangeAttribute: PropTypes.func,
        handleInlineChange: PropTypes.func,
        handleDayChange: PropTypes.func,
        handleViewProperty: PropTypes.func,
        statuses: PropTypes.array,
        isFetchingStatuses: PropTypes.array,
        handleChangeFilter: PropTypes.func,
        processedElements: PropTypes.array
    };

    renderTableHeader(label, name, style, sortable = true) {
        const { handleSort, sortColumn, sortType } = this.props;

        let icon = <i className="fas fa-sort" />;
        if (sortColumn === name) {
            if (sortType === 'asc') {
                icon = <i className="fas fa-sort-up" />;
            } else {
                icon = <i className="fas fa-sort-down" />;
            }
        }

        if (sortable) {
            return <th style={style}><span onClick={handleSort.bind(this, name)}>{label} {icon}</span></th>;
        }

        return <th style={style}>{label}</th>;
    }

    renderData() {
        const { processedElements, isFetchingElements, handleShowForm, handleShowDelete, selectedPage, elementsPerPage,
            handleChangeAttribute, statuses, isFetchingStatuses } = this.props;

        if (isFetchingElements || isFetchingStatuses) {
            return (
                <tr>
                    <td colSpan="7"><i className="fas fa-circle-notch fa-spin" /> Loading data...</td>
                </tr>
            );
        }

        if (processedElements.length === 0) {
            return (
                <tr>
                    <td colSpan="7">No Results</td>
                </tr>
            );
        }

        let statusesOptions = [];
        for (let i = 0; i < statuses.length; i++) {
            statusesOptions.push(<option value={statuses[i]['id']}>{statuses[i]['name']}</option>);
        }

        let data = [];
        let startIndex = (selectedPage - 1) * elementsPerPage;
        for (let i = startIndex; i < processedElements.length && i < startIndex + elementsPerPage; i++) {
            data.push(
                <tr key={i}>
                    <td>{processedElements[i]['id']}</td>
                    <td>{processedElements[i]['name']}</td>
                    <td>{processedElements[i]['customer_name']}</td>
                    <td className="editable">
                        <select name="active" value={processedElements[i]['status_id']} onChange={(event) => handleChangeAttribute(i, 'status_id', 'text', event.target.value)}>
                            {statusesOptions}
                        </select>
                    </td>
                    <td>
                        <ul style={{ paddingLeft: 0, marginBottom: 0 }}>
                            {processedElements[i]['machines_names'].map((name, index) => {
                                if (name == null) {
                                    return null;
                                }
                                return <li key={index}>{name}</li>;
                            })}
                        </ul>
                    </td>
                    <td>{processedElements[i]['created_by_name']}</td>
                    <td>{moment(processedElements[i]['created_at']).format('MM/DD/YYYY')}</td>
                    <td>
                        <div className="actions">
                            <Tooltip title="Edit" position="bottom" arrow size="small" className="action-tooltip">
                                <i className="fas fa-edit" onClick={handleShowForm.bind(this, processedElements[i]['id'], null)} />
                            </Tooltip>
                            <Tooltip title="Delete" position="bottom" arrow size="small" className="action-tooltip">
                                <i className="fas fa-trash" onClick={handleShowDelete.bind(this, processedElements[i]['id'])} />
                            </Tooltip>
                        </div>
                    </td>
                </tr>
            );
        }

        return data;
    }

    renderSearchField(name) {
        const { handleChangeFilter } = this.props;
        return (
            <th className="search-th">
                <input type="text" name={name} className="search-input" onChange={handleChangeFilter.bind(this, name)} />
            </th>
        );
    }

    renderSearchSelect(name, options) {
        const { handleChangeFilter } = this.props;
        return (
            <th className="search-th">
                <select type="text" name={name} className="search-input" onChange={handleChangeFilter.bind(this, name)} >
                    {options.map((option, index) => {
                        return (
                            <option key={index} value={option['value']}>{option['label']}</option>
                        );
                    })}
                </select>
            </th>
        );
    }

    render() {
        const { processedElements, totalPages, selectedPage, elementsPerPage, statuses } = this.props;

        let statusesOptions = [{ label: '', value: '' }];
        for (let i = 0; i < statuses.length; i++) {
            statusesOptions.push({ label: statuses[i]['name'], value: statuses[i]['id'] });
        }

        return (
            <div id="tables-container" className="production-container">
                <div className="table-container table-hover">
                    <table id="titles-table" className="table table-sm">
                        <thead>
                            <tr>
                                {this.renderTableHeader('ID', 'id', { width: '5%' })}
                                {this.renderTableHeader('Title', 'name', { width: 'calc(28% - 90px)' })}
                                {this.renderTableHeader('Customer', 'customer_name', { width: '17%' })}
                                {this.renderTableHeader('Status', 'status_id', { width: '9%' })}
                                {this.renderTableHeader('Equipment', 'machines_names', { width: '20%' })}
                                {this.renderTableHeader('Created By', 'created_by_name', { width: '12%' })}
                                {this.renderTableHeader('Created At', 'created_at', { width: '9%' })}
                                <th style={{ width: 90 }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                {this.renderSearchField('id')}
                                {this.renderSearchField('name')}
                                {this.renderSearchField('customer_name')}
                                {this.renderSearchSelect('status_id', statusesOptions)}
                                {this.renderSearchField('machines_names')}
                                {this.renderSearchField('created_by_name')}
                                {this.renderSearchField('created_at')}
                                <th className="search-th"></th>
                            </tr>
                            {this.renderData()}
                        </tbody>
                    </table>
                    <Pagination.Container
                        totalItems={processedElements.length}
                        totalPages={totalPages}
                        selectedPage={selectedPage}
                        elementsPerPage={elementsPerPage}
                    />
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

export default Table;
